import { isInsideViewport } from '../../utility/utility_controller'
import { Utility } from '../../utility/utility_controller'

/**
 * Stack columns are excluded from the main jQuery selector (.col:not(.type-stack)); only inner .col match.
 * When the stack has a visible background color, we animate the whole stack as one "card" (see getColumnsToAnimate).
 */
function stackHasBackgroundColor(stackCol) {
	if (!stackCol || !stackCol.classList || !stackCol.classList.contains('type-stack')) {
		return false
	}
	const inline = stackCol.getAttribute('style') || ''
	if (/background-color\s*:\s*(?!transparent|rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*0\s*\))/i.test(inline)) {
		return true
	}
	if (/background\s*:\s*(?!none|transparent)/i.test(inline)) {
		return true
	}
	if (stackCol.style && stackCol.style.backgroundColor && stackCol.style.backgroundColor !== '' && stackCol.style.backgroundColor !== 'transparent') {
		return true
	}
	try {
		const bgc = window.getComputedStyle(stackCol).backgroundColor
		if (bgc && bgc !== 'rgba(0, 0, 0, 0)' && bgc !== 'transparent') {
			return true
		}
	} catch (e) {}
	return false
}

const ROW_BACKGROUND_SELECTOR = '.row.has-background > .lay-row-bg-color, .row.has-background > .background-image, .row.has-background > .background-video, .row.has-background > .lay-webgl-slideshow, .row.has-background > .lay-row-canvas-animation:not(.lay-row-canvas-animation-field-zoom), .row.has-background > .lay-row-bg-color-fade, .row > .lay-row-gutter-bg'
let rowBackgroundStaggerGroupId = 0
const shouldAnimateRowBackgroundsOnScroll = () => {
	const val = layData.misc_options_scroll_transition_animate_row_backgrounds
	return val == null || val === true || val === '1' || val === 1 || val === 'on'
}

function getRowBackgroundStaggerGroupKey(row) {
	if (!row._layNavRowBackgroundStaggerGroupKey) {
		rowBackgroundStaggerGroupId++
		row._layNavRowBackgroundStaggerGroupKey = 'row-background-' + rowBackgroundStaggerGroupId
	}
	return row._layNavRowBackgroundStaggerGroupKey
}

function addRowBackgroundsToAnimate(row, colsInViewport, yOffset, rowBackgroundsAdded) {
	if (!row || !shouldAnimateRowBackgroundsOnScroll()) {
		return
	}
	const rowBackgrounds = row.querySelectorAll(ROW_BACKGROUND_SELECTOR)
	const staggerGroupKey = getRowBackgroundStaggerGroupKey(row)
	rowBackgrounds.forEach((rowBackground) => {
		if (rowBackgroundsAdded.has(rowBackground)) {
			return
		}
		if (isInsideViewport(rowBackground, yOffset)) {
			rowBackground._layNavStaggerGroupKey = staggerGroupKey
			rowBackgroundsAdded.add(rowBackground)
			colsInViewport.push(rowBackground)
		}
	})
}

function addTargetsToAnimate($targets, colsInViewport, yOffset, in_or_out) {
	$targets.each(function () {
		if (in_or_out == 'transition_in' && shouldSkipTransitionInForOwnNonScrubAnimation(this)) {
			return
		}
		if (isInsideViewport(this, yOffset)) {
			colsInViewport.push(this)
		}
	})
}

function getOwnNonScrubAnimationTarget(el) {
	if (!el || !el.matches) {
		return null
	}
	if (el.matches('[data-lay-scroll-anim="1"][data-lay-scroll-anim-scrub="0"]')) {
		return el
	}
	return el.querySelector('[data-lay-scroll-anim="1"][data-lay-scroll-anim-scrub="0"]')
}

function shouldSkipTransitionInForOwnNonScrubAnimation(el) {
	const scrollAnimTarget = getOwnNonScrubAnimationTarget(el)
	return !!(scrollAnimTarget && !scrollAnimTarget.hasAttribute('data-lay-sync-nav-anim'))
}

var getColumnsToAnimate = function ($columns, transition_type, in_or_out) {
	let ignore = ['no-animation']
	if (in_or_out == 'transition_in') {
		ignore.push('only-animate-out')
	}
	if (in_or_out == 'transition_out') {
		ignore.push('only-animate-in')
	}
	var colsInViewport = []
	var fpEnabled = document.documentElement.classList.contains('fp-enabled')
	// this includes stagger and up/down transitions
	// cannot only target stagger transitions here, bc thumbnailgrid animation wouldnt look right
	// for up down transition
	var animateInDetail = transition_type.indexOf('stagger') != -1 || transition_type.indexOf('up') != -1 || transition_type.indexOf('down') != -1
	// just targeting cols and .col inside stack
	var yOffset = 0

	// For transition_in stagger-up, include elements just below the fold so
	// they can move into view. For transition_out, keep the viewport strict:
	// targets below the fold are invisible and should not join the out stagger.
	if (transition_type == 'stagger-up' && in_or_out === 'transition_in') {
		yOffset = Utility.isPhoneSize ? parseInt(layData.misc_options_scroll_transition_offset_mobile) : parseInt(layData.misc_options_scroll_transition_offset_desktop)
	}

	var stacksAddedAsOne = new WeakSet()
	var rowBackgroundsAdded = new WeakSet()

	$columns.each(function () {
		if (!isInsideViewport(this, yOffset)) {
			return
		}

		let shouldAnimate = true
		// "Sync with Navigation Animation" override: if this col
		// (or one of its descendants) opted into nav-anim sync, the
		// user wants the col to participate in the transition_in
		// cascade — even if it was otherwise marked `only-animate-out`
		// or `no-animation`. Skip the ignore filter for sync cols.
		let isSyncCol = false
		if (in_or_out == 'transition_in') {
			isSyncCol = !!this.querySelector('[data-lay-sync-nav-anim="1"]')
		}
		if (!isSyncCol) {
			for (let i = 0; i < ignore.length; i++) {
				if (this.classList.contains(ignore[i])) {
					shouldAnimate = false
				}
			}
		}
		if (!shouldAnimate) {
			return
		}
		if (in_or_out == 'transition_in' && shouldSkipTransitionInForOwnNonScrubAnimation(this)) {
			return
		}

		// if fullpage js is enabled, we need to check if the containing row is visible, not just by its position,
		// but also by whether its containing row is visibility: hidden
		// (happens in case of "Fading Effect" fullpage js setting)
		// if the element is one that is placed freely, we don't need the check if its row is visible for now :)
		// var $row = jQuery(this).closest('.row')
		var $row = this.closest('.row')
		if (fpEnabled && !this.classList.contains('place-freely') && (!$row || window.getComputedStyle($row).visibility == 'hidden')) {
			return
		}

		// Inside a stack with background: one stagger target (the stack .col), not each inner element
		var stackParent = this.closest && this.closest('.col.type-stack')
		if (animateInDetail && stackParent && stackHasBackgroundColor(stackParent)) {
			if (!stacksAddedAsOne.has(stackParent)) {
				stacksAddedAsOne.add(stackParent)
				colsInViewport.push(stackParent)
			}
			addRowBackgroundsToAnimate(this.closest('.row'), colsInViewport, yOffset, rowBackgroundsAdded)
			return
		}

		// instead of animating the whole element, animate the elements inside elementgrid / thumbnailgrid
		// only if we stagger!
		if (animateInDetail && this.classList.contains('type-elementgrid')) {
			addTargetsToAnimate(jQuery(this).find('.element-wrap'), colsInViewport, yOffset, in_or_out)
			addTargetsToAnimate(jQuery(this).find('.lay-elementgrid-load-more-wrap'), colsInViewport, yOffset, in_or_out)
		} else if (animateInDetail && this.classList.contains('type-thumbnailgrid')) {
			var $filter = jQuery(this).find('.lay-thumbnailgrid-filter-wrap')
			if ($filter.length > 0) {
				if (isInsideViewport($filter[0], yOffset)) {
					colsInViewport.push($filter[0])
				}
			}
			addTargetsToAnimate(jQuery(this).find('.thumbnail-wrap'), colsInViewport, yOffset, in_or_out)
			addTargetsToAnimate(jQuery(this).find('.lay-thumbnailgrid-load-more-wrap'), colsInViewport, yOffset, in_or_out)
		} else if (animateInDetail && this.classList.contains('type-productsgrid')) {
			addTargetsToAnimate(jQuery(this).find('.lay-product'), colsInViewport, yOffset, in_or_out)
			addTargetsToAnimate(jQuery(this).find('.lay-productsgrid-load-more-wrap'), colsInViewport, yOffset, in_or_out)
		} else if (animateInDetail && this.classList.contains('type-carousel')) {
			// need to do this cause otherwise if carousel is sticky and already "stuck" on pageload, if i didnt do this it would mess up the carousel sizing
			jQuery(this)
				.find('.lay-carousel-wrap')
				.each(function () {
					if (isInsideViewport(this, yOffset)) {
						// if we have fullscreen slider activated with dofit, this container has these values:
						/*
                        .row.dofit .col > .thumbnail-wrap, .row.dofit .col > .html5video, .row.dofit .col > .img, .row.dofit .col > .video, .row.dofit .col > .lay-carousel-wrap.no-fixed-height {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: auto;
                            height: auto;
                        }
                        */
						// in that case, we dont want to animate it cause it will cause the carousel to change position abruptly
						if (this.closest('.dofit')) {
							return
						}
						colsInViewport.push(this)
					}
				})
		} else if (animateInDetail && this.classList.contains('type-news')) {
			// need to do this cause otherwise if carousel is sticky and already "stuck" on pageload, if i didnt do this it would mess up the carousel sizing
			jQuery(this)
				.find('.lay-news-element-row, .lay-news-load-more-wrap')
				.each(function () {
					if (isInsideViewport(this, yOffset)) {
						colsInViewport.push(this)
					}
				})
		} else {
			// normal cols
			colsInViewport.push(this)
		}

		// Also check for row background elements in the parent row
		if (animateInDetail) {
			addRowBackgroundsToAnimate(this.closest('.row'), colsInViewport, yOffset, rowBackgroundsAdded)
		}
	})

	return colsInViewport
}

export { getColumnsToAnimate }
